"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkbox;

var _CheckboxModule = _interopRequireDefault(require("../../assets/styles/components/Checkbox.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Checkbox(_ref) {
  let {
    children,
    onChange: _onChange,
    checked = false
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: _CheckboxModule.default.checkbox,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      onChange: e => {
        _onChange(e);
      },
      checked: checked
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _CheckboxModule.default.children,
      children: children && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          marginLeft: "10px"
        },
        children: children
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _CheckboxModule.default.effect
    })]
  });
}